var map = {
	"./categorize.webp": 2146,
	"./fill-blank-selection.webp": 2147,
	"./fill-blank-typing.webp": 2148,
	"./flashcards.webp": 2149,
	"./multiple-choice.webp": 2150,
	"./order.webp": 2151,
	"./single-choice.webp": 2152,
	"./true-false.webp": 2153
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3670;